import { PartView } from "src/api/generated/erp/db/types/tables/partView.ts";
import { concatWithPipe } from "src/utils/strings.tsx";

export function getPartLongName(part: PartView): string {
	return concatWithPipe(part.partNo, part.partDescription_1, part.partDescription_2);
}

export function getPartRevisionShortDescription({
	revisionNumber,
	note,
}: {
	revisionNumber: number | null | undefined;
	note: string | null | undefined;
}): string {
	if (revisionNumber == null) return "";
	if (note == null || note.trim() === "") return `${revisionNumber}`;
	return `${revisionNumber} | ${note.slice(0, 4)}`;
}
